function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 722.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bot_d") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "633.87 687.38 398.37 374.61 372.61 400.36 212.67 0.5 0.5 0.5 0 0.5 0 720.5 703.79 720.5 670.67 687.38 633.87 687.38",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "909.85 481.32 784.74 635.87 744.27 646.9 733.23 702.1 703.79 720.5 1280 720.5 1280 0.5 1081.1 0.5 909.85 481.32",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "777.94 0.5 777.94 0.5 820.31 466.6 811.18 366.18 777.94 0.5",
    style: {
      fill: "none",
      stroke: "#828282",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.72 329.22 316.03 0.5 316.03 0.5 432.72 329.22",
    style: {
      fill: "none",
      stroke: "#828282",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "633.87 687.38 670.67 687.38 432.72 329.22 398.37 374.61 633.87 687.38",
    style: {
      fill: "none",
      stroke: "#828282",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "744.27 646.9 820.31 466.6 777.94 0.5 450.69 0.5 479.33 231.1 687.84 648.13 703.79 720.5 733.23 702.1 744.27 646.9",
    style: {
      fill: "none",
      stroke: "#828282",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "811.18 366.18 820.31 466.6 909.85 481.32 952.78 289.97 811.18 366.18",
    style: {
      fill: "none",
      stroke: "#828282",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "777.94 0.5 811.18 366.18 952.78 289.97 965.05 140.33 952.84 0.5 777.94 0.5",
    style: {
      fill: "none",
      stroke: "#828282",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1029.28 0.5 1026.38 32.39 965.05 140.33 952.78 289.97 909.85 481.32 1060.11 0.5 1029.28 0.5",
    style: {
      fill: "none",
      stroke: "#828282",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "909.85 481.32 1081.1 0.5 1060.11 0.5 909.85 481.32",
    style: {
      fill: "none",
      stroke: "#828282",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "965.05 140.33 1026.38 32.39 1029.28 0.5 952.84 0.5 965.05 140.33",
    style: {
      fill: "none",
      stroke: "#828282",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.33 231.1 450.69 0.5 316.03 0.5 432.72 329.22 670.67 687.38 703.79 720.5 687.84 648.13 479.33 231.1",
    style: {
      fill: "none",
      stroke: "#828282",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.65 0.5 257.99 9.66 398.37 374.61 432.72 329.22 316.03 0.5 261.65 0.5",
    style: {
      fill: "none",
      stroke: "#828282",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.97 0.5 212.67 0.5 372.61 400.36 398.37 374.61 257.72 10.31 253.97 0.5",
    style: {
      fill: "none",
      stroke: "#828282",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.72 10.31 398.37 374.61 257.99 9.66 257.72 10.31",
    style: {
      fill: "none",
      stroke: "#828282",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "744.27 646.9 784.74 635.87 909.85 481.32 820.31 466.6 744.27 646.9",
    style: {
      fill: "none",
      stroke: "#828282",
      strokeMiterlimit: 10
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotD);
export default __webpack_public_path__ + "static/media/bot_d.cdab275afb537718cabd5916d004bd71.svg";
export { ForwardRef as ReactComponent };